import {IOfferArchivedData, isOfferArchived} from "../../../utils/is_offer_archived";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";

export const getGTMEcommerceItemStatus = (offer: IOfferArchivedData) => {
    const isArchived = isOfferArchived(offer);
    return isArchived ? GTMEcommerceItemStatus.Archived : GTMEcommerceItemStatus.Active;
};
import {IOfferArchivedData, isOfferArchived} from "../../../utils/is_offer_archived";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";

export const getGTMEcommerceItemStatus = (offer: IOfferArchivedData) => {
    const isArchived = isOfferArchived(offer);
    return isArchived ? GTMEcommerceItemStatus.Archived : GTMEcommerceItemStatus.Active;
};
